import PropTypes from 'prop-types'

/**
 * @typedef {Object} WorkAppVehicleUsers
 *
 * @property {string}  userId   - user ID
 * @property {string}  objectId  - ID of the vehicle
 * @property {string}  [pairedDate] - vehicle and user pairing timestamp
 * @property {string}  [activationCode] - activationCode
 */
export const workAppVehicleUsersPropType = PropTypes.shape({
    userId: PropTypes.string.isRequired,
    objectId: PropTypes.string.isRequired,
    pairedDate: PropTypes.string,
    activationCode: PropTypes.string
})
